import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserPrefState {
  salonCategory: string | null; // "Ladies" | "Gents" | "Kids" | "Pets"
}

const initialState: UserPrefState = {
  salonCategory: typeof window !== "undefined"
    ? localStorage.getItem("salonCategory")
    : null,
};

const userPrefSlice = createSlice({
  name: "userPref",
  initialState,
  reducers: {
    setSalonCategory: (state, action: PayloadAction<string>) => {
      state.salonCategory = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem("salonCategory", action.payload);
      }
    },
    clearSalonCategory: (state) => {
      state.salonCategory = null;
      if (typeof window !== "undefined") {
        localStorage.removeItem("salonCategory");
      }
    },
  },
});

export const { setSalonCategory, clearSalonCategory } = userPrefSlice.actions;
export default userPrefSlice.reducer;
